import React from 'react';
import moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import 'moment/locale/es';


export default function gdprPrint(condiciones:any, condiciones_adicionales:any, gdpr:any, download=false){
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  const docDefinition = {
    content: [
      { text: gdpr, style: 'header' },
      ' ',
      condiciones,
      ' ',
      ' ',
      condiciones_adicionales.map((condicion:any) => `___    ${condicion.descripcion_larga}\n\n`),
      ' ',
      ' ',
      ' ',
      { text: '_____________________________', alignment: 'center' },
      { text: 'Firma', alignment: 'center' },
      { text: moment().locale('ES').format('LL'), alignment: 'center' },
    ],
    styles: {
      header: {
        fontSize: 22,
        bold: true,
      },
    },
  };
  if(download){
    pdfMake.createPdf(docDefinition).download();
  }
  else pdfMake.createPdf(docDefinition).print();
};